import {
    apiRequest,
    pangkatP3KList,
    pangkatP3KActive,
    pangkatP3KInactive
} from "../../../../../services/adapters/master/pangkatP3KService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", pangkatP3KList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", pangkatP3KInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", pangkatP3KActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository